import { Card } from '../components/ui/Card';
import { CodeSnippet } from '../components/ui/CodeSnippet';
import { TechSelector } from '../components/ui/TechSelector';

import { useAccountNumber } from '/src/hooks';
import { VideoPlayer } from '/src/components/VideoPlayer';
import { ListItem } from '../components/ui/ListItem';
import { SupportLink } from '../../_global/components/SupportLink';
import { SupportLinks } from '/src/support';
import DrupalPoster from '/src/features/installation/assets/drupal8-instructions-poster.jpg';
import DrupalVideo from '/src/features/installation/assets/drupal8-instructions.mp4';

export function DrupalInstructions({ techOptions = [], selectedTechOption = null, onSelectTech }) {
  const [accNumber] = useAccountNumber(false);

  return (
    <Card className="max-w-[720px] w-full mt-5 mb-6">
      <div className="mb-4 flex w-full flex-col gap-3 md:flex-row md:items-center">
        <h2 className="flex-1 text-lg font-bold leading-9 text-black-pearl-500">Instructions</h2>
        <TechSelector techOptions={techOptions} selectedTechOption={selectedTechOption} onSelectTech={onSelectTech} />
      </div>

      <ol className="flex flex-col gap-4 mb-4">
        <ListItem number={1}>
          Go to your Drupal administration page. Click on <strong>Extend &gt; + Install new module.</strong>
        </ListItem>

        <ListItem number={2}>
          Copy and paste this URL,{' '}
          <span className="break-all">https://ftp.drupal.org/files/projects/crazyegg-8.x-1.4.tar.gz</span> into the{' '}
          <strong>Install from a URL</strong> text field. Click on <strong>Install.</strong>
        </ListItem>

        <ListItem number={3}>
          Click on <strong>Extend.</strong> Find Crazy Egg and make sure it is selected. Click on{' '}
          <strong>Install.</strong>
        </ListItem>

        <ListItem number={4}>
          Go to <strong>Administration &gt; Configuration &gt; System &gt; Crazy Egg.</strong>
        </ListItem>

        <ListItem number={5}>
          Copy and paste your account number, {accNumber} into the Crazy Egg Account ID input field.
        </ListItem>
      </ol>

      <CodeSnippet code={accNumber} />

      <ol className="flex flex-col gap-4 mt-4">
        <ListItem number={6}>
          Click on <strong>Save configuration.</strong>
        </ListItem>
      </ol>

      <div className="mt-4 rounded bg-white-lilac-500 px-6 py-5 text-base font-normal leading-6 text-black-pearl-500">
        <p>
          <strong>Note:</strong> If you are using a cache plugin on your site, you will need to clear it after you have
          installed your Crazy Egg code.
        </p>
      </div>

      <p className="mt-10 text-base font-normal leading-6 text-black-pearl-500 mb-3">
        Watch this video to see these steps:
      </p>

      <VideoPlayer src={DrupalVideo} poster={DrupalPoster} label="Drupal installation video" />

      <div className="flex flex-col gap-1 mt-3">
        <SupportLink
          href={SupportLinks.install.drupal8}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Drupal Setup Guide
        </SupportLink>
        <SupportLink
          href={SupportLinks.general.newSupportRequest}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Contact Support
        </SupportLink>
      </div>

      <p className="mt-3 text-black-pearl-500">
        Click on <strong>Check installation</strong> once you have connected Crazy Egg with Google Tag Manager.
      </p>
    </Card>
  );
}
